import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { finalize, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { AuthService } from '@core/services/authentication/auth.service';
import { StorageService, STORAGE_KEY } from '@core/services/storage/storage.service';
import { ChatbotService } from '@core/services/chatbot/chatbot.service';
import { RouterMenu } from '@core/config/routing-menu';
import { SdkStateService } from '../../../mosaic/services/sdk-state.service';

/**
 * Servicio creado para centralizar el flujo de cierre de sesión.
 */
@Injectable({ providedIn: 'root' })
export class SessionService {
  private isLogoutInProgress = false;

  constructor(
    private readonly authService: AuthService,
    private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly chatbotService: ChatbotService,
     private readonly sdkStateService: SdkStateService
  ) {}

  logout(): Observable<void> {
    if (this.isLogoutInProgress) {
      // Evita ejecutar múltiples flujos de logout en paralelo.
      return of(void 0);
    }

    this.isLogoutInProgress = true;

    return this.authService.logout().pipe(
      catchError(() => of(void 0)),
      finalize(() => {
        this.navigateToLoginAndClearState();
        this.isLogoutInProgress = false;
      }),
    );
  }

  private navigateToLoginAndClearState(): void {
    this.storageService.removeItem(STORAGE_KEY.TOKEN);
    this.storageService.removeItem(STORAGE_KEY.TRUSTED_DEVICE_REGISTERED);
    localStorage.clear();
     this.sdkStateService.clearState();

    this.chatbotService.removeScript();
    this.chatbotService
      .loadScript()
      .catch((err) => console.error('Error recargando el chatbot', err));

    this.router.navigate([RouterMenu.LOGIN]);
  }
}
